(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat.js');
'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Link
} = ReactRouterDOM;
const {
  Provider
} = ReactRedux;
const {
  useEffect,
  useState
} = React;
const {
  Sportinfo
} = svs.components.sportinfo.sportinfo;
const {
  EmptyNotice
} = svs.component.tipsenEmptyNotice;
const {
  combineReducers,
  configureStore
} = RTK;
const {
  sportEventReducer,
  leagueReducer,
  sportReducer,
  participantReducer,
  countryReducer,
  eventTypeStatisticReducer,
  generateParticipantsMw,
  actions: matchInfoActions
} = svs.components.sportinfo.matchInfoRedux;
const {
  gameAnalysesReducer
} = svs.components.sportinfo.gameAnalysesRedux;
const {
  newsTTReducer
} = svs.components.sportinfo.newsTT;
const {
  BigStatFallback,
  OptionalBrowserRouter
} = svs.components.sportinfo.bigstat;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const themeClass = svs.components.sportinfo.sportinfo.helpers.themeClass;
const {
  ContentHandler
} = svs.components.sportInfo.contentHandler;
const {
  BigStatBanner,
  BannerpropsHandler,
  BigstatBannerSkeleton
} = svs.components.sportInfo.bigStatBanner;
const setupStore = preloadedState => {
  const store = configureStore({
    reducer: combineReducers({
      SportEvents: sportEventReducer,
      Leagues: leagueReducer,
      Sports: sportReducer,
      Participants: participantReducer,
      Countries: countryReducer,
      EventTypeStatistic: eventTypeStatisticReducer,
      gameAnalyses: gameAnalysesReducer,
      newsTT: newsTTReducer
    }),
    middleware: getDefaultMiddleware => [...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    }), generateParticipantsMw([{
      action: matchInfoActions.updateMatchOdds,
      getMatchIdFn: action => action.payload.matchId
    }, {
      action: matchInfoActions.fetchMatchInfo.fulfilled,
      getMatchIdFn: action => action.meta.arg
    }])],
    preloadedState: _objectSpread({}, preloadedState)
  });
  return store;
};
const setScrollHeight = () => {
  var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5;
  const innerHeight = window.innerHeight || 0;
  const tabContent = document.querySelector('.js-bigstat-tab-content');
  const jsTopContentWrapper = ((_document$querySelect = document.querySelector('.js-top-content-wrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight) || 0;
  const jsProductBaseTabsNav = ((_document$querySelect2 = document.querySelector('.js-product-base-tabs-nav')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.clientHeight) || 0;
  const campaignFlerpContainer = ((_document$querySelect3 = document.querySelector('.campaign-flerp-container')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.clientHeight) || 0;
  const bigStatBanner = ((_document$querySelect4 = document.querySelector('.sportinfo-bigstat-banner')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.clientHeight) || 0;
  const menuWrapper = ((_document$querySelect5 = document.querySelector('.side-nav-statistics-menu')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.clientHeight) || 0;
  if (tabContent) {
    tabContent.style.height = "".concat(innerHeight - jsTopContentWrapper - jsProductBaseTabsNav - bigStatBanner - campaignFlerpContainer - menuWrapper, "px");
  }
};
const BigStat = _ref => {
  let {
    activeTabBasePaths = [],
    appendTabSearchParams,
    basePath = '/',
    branding,
    className,
    classNameWrapper,
    drawNumber,
    eventNumber,
    FallbackComp = EmptyNotice,
    forceSportType,
    isEnclosedInRouter = false,
    isWideDevice,
    matchId,
    modulePath = '/',
    onBannerCloseClick,
    productId,
    setCoupon,
    sportEventStatus,
    sportType,
    tabAreaClassName = 'js-bigstat-tab-content bigstat-tab-content',
    tabComponent = props => React.createElement(Link, _extends({
      replace: true
    }, props)),
    theme
  } = _ref;
  const [activeTab, setActiveTab] = useState(undefined);
  const [store] = useState(() => setupStore(undefined));
  const defaultErrorFallback = React.createElement(BigStatFallback, {
    branding: branding,
    theme: theme ? themeClass(theme.toLowerCase()) : ''
  }, "Tillf\xE4lligt fel");
  useEffect(() => {
    let timeout;
    const detectWindowResize = () => {
      timeout && window.cancelAnimationFrame(timeout);
      timeout = window.requestAnimationFrame(() => setScrollHeight());
    };
    window.addEventListener('resize', detectWindowResize);
    return () => window.removeEventListener('resize', detectWindowResize);
  }, []);
  useEffect(() => {
    if (isWideDevice || !svs.core.detect.formfactor.mobile()) {
      const bigStatEl = document.querySelector('.js-bigstat-tab-content div');
      let resizeTimer;
      let selectorTimer;
      const runResizeTimer = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          setScrollHeight();
        }, 250);
      };
      const resizeObserver = new ResizeObserver(() => {
        runResizeTimer();
      });
      if (bigStatEl) {
        resizeObserver.observe(bigStatEl);
      } else {
        const runSelectorTimer = () => {
          clearTimeout(selectorTimer);
          selectorTimer = setTimeout(() => {
            const bigStatEl = document.querySelector('.js-bigstat-tab-content div');
            bigStatEl && resizeObserver.observe(bigStatEl);
          }, 250);
        };
        runSelectorTimer();
      }
      return () => {
        if (bigStatEl) {
          resizeObserver.unobserve(bigStatEl);
        }
        clearTimeout(resizeTimer);
        clearTimeout(selectorTimer);
      };
    }
  }, [isWideDevice, matchId, activeTab]);
  if (!productId || !drawNumber || !matchId) {
    return defaultErrorFallback;
  }
  const menuOptions = {
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  };
  const ContentHandlerProps = sportType !== undefined && sportEventStatus !== undefined ? {
    sportType,
    forceSportType,
    sportEventStatus,
    productId,
    matchId
  } : {
    forceSportType,
    matchId,
    productId,
    forceFetchSportEvent: true
  };
  return React.createElement(ErrorBoundary, {
    fallback: () => defaultErrorFallback
  }, React.createElement(Provider, {
    store: store
  }, React.createElement(OptionalBrowserRouter, {
    basename: modulePath,
    isEnclosedInRouter: isEnclosedInRouter
  }, React.createElement("div", {
    className: "".concat(classNameWrapper ? classNameWrapper : '', " ").concat(theme ? themeClass(theme.toLowerCase()) : ''),
    "data-testid": "bigstat"
  }, React.createElement(ContentHandler, ContentHandlerProps, _ref2 => {
    let {
      menuItems,
      content,
      matchStateProps,
      lazyComponentsMap
    } = _ref2;
    return React.createElement(React.Fragment, null, React.createElement(BannerpropsHandler, {
      matchId: matchId
    }, (_ref3, isLoading) => {
      let {
        homeTeam,
        awayTeam,
        leagueName,
        sportType,
        startTime,
        results,
        odds,
        sportEventStatus,
        statusTime
      } = _ref3;
      if (isLoading || !matchStateProps.matchState) {
        return React.createElement(BigstatBannerSkeleton, null);
      }
      return React.createElement(BigStatBanner, {
        awayTeam: awayTeam,
        homeTeam: homeTeam,
        leagueName: leagueName,
        matchId: matchId,
        matchState: matchStateProps.matchState,
        odds: odds,
        onCloseClick: onBannerCloseClick,
        results: results,
        sportEventStatus: sportEventStatus,
        sportType: sportType,
        startTime: startTime,
        statusTime: statusTime
      });
    }), React.createElement(Sportinfo, {
      activeTabBasePaths: activeTabBasePaths,
      appendTabSearchParams: appendTabSearchParams,
      basePath: basePath,
      branding: branding,
      className: "".concat(className ? className : ''),
      content: content,
      drawNumber: drawNumber,
      eventNumber: eventNumber,
      FallbackComp: FallbackComp,
      isWideDevice: isWideDevice,
      lazyComponentsMap: lazyComponentsMap,
      matchId: matchId,
      matchState: matchStateProps.matchState,
      menuItems: menuItems,
      menuOptions: menuOptions,
      productId: productId,
      setActiveTab: setActiveTab,
      setCoupon: setCoupon,
      sportType: matchStateProps.sportType,
      tabAreaClassName: tabAreaClassName,
      tabComponent: tabComponent,
      theme: theme
    }));
  })))));
};
setGlobal('svs.components.sportinfo.bigstat.BigStat', BigStat);

 })(window);